/* eslint-disable react/no-danger */
import React from 'react';

export default function blockDescription(bemClasses, data) {
  if (!data) return null;

  return (
    <div {...bemClasses('blockDescription')}>
      <div {...bemClasses('content')} itemProp="description">
        <span
          {...bemClasses('text')}
          dangerouslySetInnerHTML={{ __html: data }}
        />
      </div>
    </div>
  );
}
